import Filter from '../Filter';

export default class FilterRange extends Filter {
  validate(item, filter) {
    Object.keys(filter).forEach((key) => {
      const rangeItems = filter[key].value[0];

      if (!rangeItems) {
        return;
      }

      const value = Number(item[key]);
      const range = rangeItems.split(',');

      if (value > range[0] && value <= range[1]) {
        return;
      }

      this.addIsValid(false);
    });
  }
}
